import React from 'react'
import { PickupTableClientBlock } from './../../../../../Components/City/Page/Pickup/PickupTable/ClientBlock'
import { Col, Row } from 'react-bootstrap'

const PickupClientSection = props => (
  <div className={props.className}>
    <div className="table-header" />
    <Row className="client-name">
      <Col xs={12}>
        <PickupTableClientBlock>
          <div>
            <img className="client-logo" src={props.logo} alt={props.name} />
          </div>
          <div className="client">{props.name}</div>
        </PickupTableClientBlock>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>{props.children}</Col>
    </Row>
  </div>
)

export default PickupClientSection
